module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.solidtectecnologia.com.br/"
    }
  }, [_vm._v("SolidTec Tecnologia")]), _vm._v(".")]), _vm._v(" Todos os direitos reservados.\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465b0f23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 1568
// module chunks = 1